/**
 * Created by admin on 2017/4/21.
 */
export default {
    saveSession(state, user) {
        state.sysSid = user.Sid;
        state.sysSession = user.Session;
        state.sysUserName = user.RealName;
    },
    saveRouterName(state, routerName) {
        state.routerName = routerName;
    },
    saveCustomerLevelList(state, customerLevelList) {
        state.customerLevelList = customerLevelList;
    },
    saveCustomerSourceList(state, customerSourceList) {
        state.customerSourceList = customerSourceList;
    },
    saveAgentTypeList(state, agentTypeList) {
        state.agentTypeList = agentTypeList;
    },
    saveAgentList(state, AgentList) {
        state.AgentList = AgentList;
    },
    saveProjectTypeSignMateriel(state, Data) {
        state.ProjectTypeSignMateriel = Data
    },
    saveAllCity(state, Data) {
        state.allCity = Data;
    },
    saveAllProvince(state, Data) {
        state.allProvince = Data;
    }
}


// WEBPACK FOOTER //
// ./src/vuex/mutations.js